import React from 'react';
import styled from 'styled-components';

import useColors from 'hooks/use-colors';
import useTranslation from 'hooks/use-translation';

import MenuIcon from 'assets/menu-icon';
import { AnchorButton } from 'components/core/button/anchor-button';

type ShopButtonProps = {
  onClick: () => void;
};

export function ShopButton({ onClick }: ShopButtonProps): JSX.Element {
  const colors = useColors();
  const { t } = useTranslation();

  return (
    <StyledAnchor onClick={onClick}>
      <MenuIcon fill={colors.white} height={24} width={24} /> {t('common.shop', 'Shop')}
    </StyledAnchor>
  );
}

const StyledAnchor = styled(AnchorButton)`
  text-transform: unset;
  background: ${({ theme }) => theme.colors.opal04};
  width: fit-content;
  height: 44px;
  border-radius: 7px;
  font-size: 18px;
  display: flex;
  align-items: center;
  margin: 0 16px 0 -12px;
  &:hover {
    background: ${({ theme }) => theme.colors.opal05};
  }
  svg {
    margin-top: 7px;
  }
`;
